import { SyntheticEvent } from "react";

const API_ORIGIN = "https://api.lehieucomputer.com";
const UPLOAD_PATTERN = /^(?:https?:\/\/api\.lehieucomputer\.com)?\/uploads\/([^/?#]+)$/;

// Uploaded photos are often several MB; the API serves resized WebP copies at /thumb/{width}/{file}.
// Width must be one the API allows (300, 600, 1200).
export const thumbUrl = (src: string | undefined, width: 300 | 600 | 1200 = 600) => {
  if (!src) return src;
  const match = src.match(UPLOAD_PATTERN);
  return match ? `${API_ORIGIN}/thumb/${width}/${match[1]}` : src;
};

// Fall back to the original file if the thumbnail cannot be loaded.
export const fallbackToOriginal = (original: string | undefined) => (event: SyntheticEvent<HTMLImageElement>) => {
  const img = event.currentTarget;
  if (!original || img.dataset.fallback) return;
  img.dataset.fallback = "1";
  img.src = original.startsWith("/") ? `${API_ORIGIN}${original}` : original;
};
